import * as React from 'react';

const Arrangement = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={40} height={41} fill="none" viewBox="0 0 40 41" {...props}>
        <g clipPath="url(#arrangement_a)">
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="m25.164 6.652 1.265-4.274-6.531 1.266-6.532-1.266 1.265 4.273m10.533 0-2.179 7.362a7.26 7.26 0 0 0-3.062-.673 7.26 7.26 0 0 0-3.106.694L14.63 6.65m10.533 0a14.98 14.98 0 0 1 8.696 8.677M14.63 6.651a14.98 14.98 0 0 0-8.695 8.677m27.924 0-7.353 2.177c.449.945.7 2.003.7 3.119a7.26 7.26 0 0 1-.68 3.075l7.35 2.176m-.017-10.547 4.259-1.26-1.266 6.53 1.266 6.532-4.241-1.255M5.936 15.328l-4.26-1.26 1.267 6.53-1.266 6.532 4.24-1.255m.019-10.547 7.397 2.19a7.26 7.26 0 0 0-.694 3.106c0 1.094.241 2.131.673 3.062l-7.394 2.189m0 0a14.98 14.98 0 0 0 8.7 8.719m0 0-1.252 4.226 6.532-1.266 6.531 1.266-1.25-4.226m-10.562 0 2.187-7.386c.945.449 2.003.7 3.119.7 1.099 0 2.14-.244 3.075-.68l2.18 7.366m0 0a14.98 14.98 0 0 0 8.7-8.72m-6.73-5.249a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0"
            />
        </g>
        <defs>
            <clipPath id="arrangement_a">
                <path fill="#fff" d="M0 0h40v41H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default Arrangement;
